import type { IElectronService } from './IElectronService';

/**
 * ElectronService - Production implementation of IElectronService.
 *
 * Delegates to the Electron preload bridge (window.playcast.electronFunctions).
 */
export class ElectronService implements IElectronService {
  public copyToClipboard(text: string): void {
    const electronFns = (window as any).playcast?.electronFunctions;
    if (electronFns?.copyToClipboard) {
      electronFns.copyToClipboard(text);
    }
  }

  public hostLogin(): void {
    const electronFns = (window as any).playcast?.electronFunctions;
    if (electronFns?.hostLogin) {
      electronFns.hostLogin();
    }
  }

  public isAvailable(): boolean {
    return !!(window as any).playcast?.electronFunctions;
  }
}
